import { type LeadChecklistItem } from "../../types/lead.types.ts"

interface LeadChecklistProgress {
  total: number
  completed: number
  percent: number
}

const leadChecklistProgress = (
  checklist?: LeadChecklistItem[] | null
): LeadChecklistProgress => {
  const items = checklist ?? []
  const total = items.length
  const completed = items.filter((item) => !!item?.is_done).length

  return {
    total,
    completed,
    percent: total ? Math.round((completed / total) * 100) : 0
  }
}

export { type LeadChecklistProgress, leadChecklistProgress }
